import React from 'react';
import PropTypes from 'prop-types';
import modalManager from '../../modules/modalManager';
import Janitor from '../../modules/Janitor';
import ManagedModal from './ManagedModal';

/**
 * Helper for ModalTrigger when rendering without a ModalHost. This works in scenarios where
 * modalManager may have been used in the past.
 *
 * This should be deleted this after modalManager is removed.
 */
export default class AngularModalTrigger extends React.Component {
  static hasContext() {
    return !!modalManager.getContainer();
  }

  static propTypes = {
    // eslint-disable-next-line
    triggerType: PropTypes.elementType.isRequired,
    renderModal: PropTypes.func.isRequired,
    renderTrigger: PropTypes.func,
    // eslint-disable-next-line
    onTriggerClick: PropTypes.func,
    // eslint-disable-next-line
    onModalOpen: PropTypes.func,
    // eslint-disable-next-line
    onModalClose: PropTypes.func,
    initialOpen: PropTypes.bool,
  };

  static defaultProps = {
    renderTrigger: null,
    onTriggerClick: null,
    onModalOpen: null,
    onModalClose: null,
    initialOpen: false,
  };

  janitor = new Janitor();
  managedModal = null;

  constructor(props) {
    super(props);
    this.managedModal = new ManagedModal(props);

    this.janitor.addCleanup(() => {
      if (this.managedModal) {
        this.managedModal.cleanup();
      }
    });
  }

  componentDidMount() {
    const { renderTrigger, initialOpen } = this.props;

    // Open immediately if no renderTrigger is provided
    if (!renderTrigger || initialOpen) {
      this.handleOpen();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.renderTrigger !== prevProps.renderTrigger
        || this.props.renderModal !== prevProps.renderModal)
      && !this.managedModal.isOpen
    ) {
      this.managedModal = new ManagedModal(this.props);
    }
  }

  componentWillUnmount() {
    this.janitor.cleanup();
  }

  handleOpen = () => {
    this.managedModal.open();
  };

  handleClose = result => {
    this.managedModal.close(result);
  };

  render() {
    const { renderTrigger } = this.props;

    // Render trigger or nothing if opening immediately
    return renderTrigger ? renderTrigger(this.handleOpen) : null;
  }
}
